import useSearchResults from '@/src/hooks/srp/useSearchResults'
import { Typography } from '@mui/material'
import { useTranslations } from 'next-intl'

export const PerAdultLabel = () => {
    const { isPerPaxPricingEnabled } = useSearchResults()
    const t = useTranslations('common')

    if (!isPerPaxPricingEnabled) {
        return null
    }
    return (
        <Typography component={'span'} fontSize={'12px'} fontWeight={500} textTransform={'lowercase'}>
            / {t('adult')}
        </Typography>
    )
}
